import { render, staticRenderFns } from "./large-accordion.vue?vue&type=template&id=6c57e4ef"
import script from "./large-accordion.vue?vue&type=script&lang=js"
export * from "./large-accordion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports